<section class="cmn-innerpage-wrapper vacation-apply-wrapper">
  <form [formGroup]="vacationApplyForm">
    <div class="heading">
      <div class="totalBalance" *ngIf="availableLeave">
        <h2>{{ availableLeave < 0 ? 'LOP' : 'Available Leave' }} : {{ availableLeave < 0 ? -availableLeave : availableLeave }} days</h2>
      </div>
      <div class="totalBalance">
        <h2>Balance : {{leaveBalance < 0 ? 0 :  leaveBalance || 0}} days</h2>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <div class="totalBalance">
          <h3>Passport Expiry Date: <span> {{ (passportExpiryDate | date: 'd MMMM y') || '--'}}</span></h3>
          <h3>Visa Expiry Date: <span> {{ (visaExpiryDate | date: 'd MMMM y') || '--' }}</span></h3>
        </div>
        <div class="totalBalance">
          <h3>Leave period</h3>
          <span>{{ (leavePeriodStart | date: 'd MMMM y') || '--'}} - {{ (leavePeriodEnd | date: 'd MMMM y') || '--' }}</span>
          <h3>Due Date: <span> {{ (dueDate | date: 'd MMMM y') || '--' }}</span></h3>
        </div>
      </div>
    </div>

    <div class="vacation-inputs">

      <div class="form-wrapper full-width-form">
        <label class="checkbox-wrapper">
          <input type="checkbox" formControlName="isTicketEligible" />Is Ticket Eligible
          <span class="checkmark"></span>
        </label>
        <label class="checkbox-wrapper">
          <input type="checkbox" formControlName="isSpouseTicket" />Is Spouse Ticket
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-wrapper" *ngIf="!employeeId">
        <span>
          <label for="">Employee Name <span class="red">*</span></label>
        </span>
        <mat-form-field>
          <mat-select placeholder="Select Employee" formControlName="employeeId">
            <mat-option *ngFor="let employee of employees" [value]="employee?.id">
              {{ employee?.firstName }}
            </mat-option>
          </mat-select> </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error *ngIf="
                 vacationApplyForm.get('employeeId')!?.touched &&
                 vacationApplyForm.get('employeeId')?.hasError('required')">
              Employee is required
            </mat-error>
          </span>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">From Date <span class="red">*</span></label>
        <mat-form-field>
          <input matInput [matDatepicker]="pickerFrom" formControlName="startDate" [matDatepickerFilter]="dateFilter"
            placeholder="Choose date" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </mat-form-field>
        <div *ngIf="
              vacationApplyForm.get('startDate')!.invalid &&
              vacationApplyForm.get('startDate')!.touched
            " class="error">
          From date is required.
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Duration <span class="red">*</span></label>
        <mat-form-field>
          <mat-select placeholder="Select duration" formControlName="duration">
            <mat-option value="7">7 days</mat-option>
            <mat-option value="14">14 days</mat-option>
            <mat-option value="21">21 days</mat-option>
            <mat-option value="Custom">Custom</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="
          vacationApplyForm.get('duration')!.invalid &&
          vacationApplyForm.get('duration')!.touched
          " class="error">
          Duration is required.
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">To Date <span class="red">*</span></label>
        <mat-form-field>
          <input matInput [matDatepicker]="pickerTo" [matDatepickerFilter]="dateFilter" formControlName="endDate"
            placeholder="Choose date" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>
        <!-- <h2>Balance : {{leaveBalance}}</h2> -->
        <div *ngIf="
              vacationApplyForm.get('endDate')!.invalid &&
              vacationApplyForm.get('endDate')!.touched
            " class="error">
          To date is required.
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Last Working Date<span class="red">*</span></label>
        <mat-form-field>
          <input matInput [matDatepicker]="pickerLast" [matDatepickerFilter]="dateFilter"
            formControlName="lastWorkingDate" placeholder="Choose date" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerLast"></mat-datepicker-toggle>
          <mat-datepicker #pickerLast></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-wrapper">
        <label for="">Due Back Date<span class="red">*</span></label>
        <mat-form-field>
          <input matInput [matDatepicker]="pickerBack" [matDatepickerFilter]="dateFilter" formControlName="dueBackDate"
            placeholder="Choose date" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerBack"></mat-datepicker-toggle>
          <mat-datepicker #pickerBack></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-wrapper">
        <label for="">Date Of Travel<span class="red">*</span></label>
        <mat-form-field>
          <input matInput [matDatepicker]="pickerTravel" [matDatepickerFilter]="dateFilter" formControlName="travelDate"
            placeholder="Choose date" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerTravel"></mat-datepicker-toggle>
          <mat-datepicker #pickerTravel></mat-datepicker>
        </mat-form-field>
        <div *ngIf="
              vacationApplyForm.get('travelDate')!.invalid &&
              vacationApplyForm.get('travelDate')!.touched
            " class="error">
          Travel date is required.
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Travel From<span class="red">*</span></label>
        <mat-form-field>
          <input matInput placeholder="From" formControlName="travelFrom">
        </mat-form-field>
        <div *ngIf="
              vacationApplyForm.get('travelFrom')!.invalid &&
              vacationApplyForm.get('travelFrom')!.touched
            " class="error">
          Travel from is required.
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Travel To<span class="red">*</span></label>
        <mat-form-field>
          <input matInput placeholder="To" formControlName="travelTo">
        </mat-form-field>
        <div *ngIf="
              vacationApplyForm.get('travelTo')!.invalid &&
              vacationApplyForm.get('travelTo')!.touched
            " class="error">
          Travel to is required.
        </div>
      </div>
      <div class="form-wrapper" *ngIf="vacationApplyForm.get('isSpouseTicket')?.value">
        <label for="">Travel From (Spouse)</label>
        <mat-form-field>
          <input matInput placeholder="To" formControlName="travelFromOfSpouse">
        </mat-form-field>
      </div>
      <div class="form-wrapper" *ngIf="vacationApplyForm.get('isSpouseTicket')?.value">
        <label for="">Travel To (Spouse)</label>
        <mat-form-field>
          <input matInput placeholder="To" formControlName="travelToOfSpouse">
        </mat-form-field>
      </div>
      <div class="form-wrapper" *ngIf="vacationApplyForm.get('isSpouseTicket')?.value">
        <label for="">Travel Date Of Spouse</label>
        <mat-form-field>
          <input matInput [matDatepicker]="pickerSpouse" [matDatepickerFilter]="dateFilter"
            formControlName="travelDateOfSpouse" placeholder="Choose date" />
          <mat-datepicker-toggle matIconSuffix [for]="pickerSpouse"></mat-datepicker-toggle>
          <mat-datepicker #pickerSpouse></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-wrapper">
        <label for="">Notes</label>
        <mat-form-field>
          <textarea matInput placeholder="Type something.." formControlName="notes"></textarea>
        </mat-form-field>
      </div>
      
    </div>
    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button class="cmn-next-btn" [disabled]="isLoading" (click)="onApplyVacation()">{{ isLoading ? 'Submitting...' :
                'Apply' }}</button>
    </div>
  </form>
  <ng-container *ngIf="employeeId || vacationHistory?.length">
    <h4>Vacation History</h4>

    <div class="salary-container">
      <div>
        <h3>Leave Period: <span>{{ (leavePeriodStart | date: 'd MMMM y') || '--'}} - {{ (leavePeriodEnd | date: 'd MMMM y') || '--' }}</span></h3>
      </div>

      <table class="salary-table">
        <ng-container *ngIf="vacationHistory?.length > 0; else noData">
          <thead>
            <tr>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Total Days</th>
              <th>Notes</th>
              <th>Approvers</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let vacation of vacationHistory">
              <td>{{ vacation?.startDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ vacation?.endDate | date: 'dd/MM/yyyy' }}</td>
              <td>{{ vacation?.totalDays || '--' }}</td>
              <td>{{ vacation?.note || '--' }}</td>
              <td>
                <ng-container *ngFor="let approver of vacation?.employee?.employeeApprovers">
                  <ng-container
                    *ngFor="let level of ['levelOneData', 'levelTwoData', 'levelThreeData', 'levelFourData', 'levelFiveData', 'levelSixData', 'levelSevenData']">
                    <div *ngIf="approver[level]">
                      {{ approver[level]?.firstName }} {{ approver[level]?.lastName }}
                    </div>
                  </ng-container>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </ng-container>

        <ng-template #noData>
          <tr>
            <td colspan="5" class="no-data" style="text-align: center;">
              No data available
            </td>
          </tr>
        </ng-template>
      </table>
    </div>
  </ng-container>

</section>